import API from '../api';

/**
 * Vehicles API Service
 * Handles all vehicle-related API operations
 */
export const vehiclesApi = {
  // Get all vehicles with optional filters
  getAll: (params = {}) => API.get('/vehicles', { params }),
  
  // Get single vehicle by ID
  getById: (id) => API.get(`/vehicles/${id}`),
  
  // Create new vehicle
  create: (data) => API.post('/vehicles', data),
  
  // Update existing vehicle
  update: (id, data) => API.put(`/vehicles/${id}`, data),
  
  // Delete vehicle
  delete: (id) => API.delete(`/vehicles/${id}`),
  
  // Search vehicles by query
  search: (query) => API.get(`/vehicles/search?q=${encodeURIComponent(query)}`),
  
  // Get available devices (Mifare cards and OBU devices)
  getAvailableDevices: async () => {
    const [mifareResponse, obuResponse] = await Promise.all([
      API.get('/admin/mifare-cards/available'),
      API.get('/admin/obu-devices/available')
    ]);
    
    return {
      mifare: mifareResponse.data,
      obu_sbu: obuResponse.data
    };
  },
  
  // Validate device availability
  validateDevice: (deviceType, deviceId) => {
    const endpoint = deviceType === 'mifare' 
      ? `/admin/mifare-cards/validate/${deviceId}`
      : `/admin/obu-devices/validate/${deviceId}`;
    return API.get(endpoint);
  },
  
  // Get truck types
  getTruckTypes: () => API.get('/wim/truck-types'),
  
  // Get active users for vehicle assignment
  getUsers: () => API.get('/vehicles/users/list'),
  
  // Assign vehicle to user
  assignToUser: (vehicleId, userId) => API.put(`/vehicles/${vehicleId}/assign`, { user_id: userId }),
  
  // Export vehicles to Excel
  exportExcel: (params = {}) => API.get('/vehicles/export', { 
    params, 
    responseType: 'blob' 
  }),
  
  // Import vehicles from Excel
  importExcel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return API.post('/vehicles/import', formData, { 
      headers: { 'Content-Type': 'multipart/form-data' } 
    });
  },
  
  // Get vehicle statistics
  getStats: () => API.get('/vehicles/stats'),
  
  // Bulk delete vehicles
  bulkDelete: (ids) => API.post('/vehicles/bulk-delete', { ids })
};

export default vehiclesApi;
